import React from 'react'
import { Container } from 'semantic-ui-react'

const PageBlock = props => {
  return <Container {...props}>{props.children}</Container>
}

export default PageBlock
